export default [
  { text: 'tipo', value: 'tipo' },
  { text: 'folio', value: 'folio' },
  { text: 'fecha emision', value: 'fecha_emision' },
  { text: 'rut vendedor', value: 'rut_vendedor' },
  { text: 'vendedor', value: 'vendedor' },
  { text: 'rut cliente', value: 'rut_cliente' },
  { text: 'cliente', value: 'cliente' },
  { text: 'doc ref', value: 'doc_ref' },
  { text: 'folio_referencia', value: 'folio_referencia' },
]
